export const navigation = new hcOffcanvasNav('#mobile-nav', {
	disableAt: 992,
	customToggle: '.toggle',
	navTitle: false,
	levelSpacing: 0,
	levelTitles: true,
	levelTitleAsBack: false,
	bodyInsert: 'append',
	insertClose: false,
});

export function bodyOverlay() {
	$('#mobile-nav li.menu-item-has-children').on('mouseover', function (e) {
		$('body').addClass('overlay');
	});

	$('#mobile-nav li.menu-item-has-children').on('mouseout', function (e) {
		$('body').removeClass('overlay');
	});
}

export function navigationFunctions(navigation) {
	navigation.on('toggle', (e, settings) => {
		$('.hamburger.main').toggleClass('open');
	});
}

export function opacityOnScroll() {
	function changeOnScroll() {
		// /alert('scrolled')
		const mainHeader = document.getElementById('header-main');
		let scrollTop = window.scrollY;
		//console.log(scrollTop)

		// if we are on the frontpage and scrolled further than 20px
		if(document.body.classList.contains('frontpage') && scrollTop > 20) {
			mainHeader.classList.add('shade')
		} else {
			mainHeader.classList.remove('shade')
		}
	}

	window.addEventListener('scroll', changeOnScroll);
}

export function toggleHeaderSearch() {
	let header = document.getElementById('headerSearch');
	let search = header.querySelector('#search');
	let searchButton = header.querySelector('.searchToggle--label');
	let searchContainer = header.querySelector('.search-input-group');
	let searchForm = header.querySelector('#header-search');
	let contact = document.querySelector('#headerContact');
	let submit = header.querySelector('#search-submit');
	let body = document.body;

	console.log(search);

	function toggleSearch() {;
		searchContainer.classList.toggle('open');
		search.focus();
	}

	// add on click to open search
	searchButton.addEventListener('click', function(e){
		// change click events based on class list
		e.preventDefault();
		toggleSearch();

		if(searchContainer.classList.contains('open')) {

			searchButton.classList.add('d-none');
			submit.classList.remove('d-none');
			contact.classList.remove('d-lg-block');
			contact.classList.add('d-lg-none');

		} else {

			searchButton.addEventListener('click', function(e) {
				searchButton.classList.remove('d-none');
				submit.classList.add('d-none');
				e.preventDefault();
				toggleSearch();
			});
			
		}
	});

	// remove open class on focus out and add event listener
	search.addEventListener('focusout', function () {
		searchContainer.classList.remove('open');
		
		contact.classList.add('d-xl-block');
		contact.classList.remove('d-lg-none');
		searchButton.addEventListener('click', function(e) {
			e.preventDefault();
			toggleSearch();
		});
	})
}
